import {
  IonPage,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonImg,
  IonText,
  useIonViewWillEnter
} from '@ionic/react'
import { constructOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { TRANSLATION_NS } from '../../lib/apollo/config'
import Header from '../Header'
import './style.scss'

interface MaintenanceScreenProps {
  title?: string | null
  message?: string | null
}

const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({
  title,
  message
}) => {
  const { t: clubT } = useTranslation(TRANSLATION_NS)

  // Apply the cert class for dark background
  useIonViewWillEnter(() => {
    document.body.classList.add('cert')
  })

  // Helper function to get translation with fallback
  const getTranslationWithFallback = (key: string, fallback: string) => {
    const translation = clubT(key)
    return translation === key ? fallback : translation
  }

  const displayTitle = title ?? getTranslationWithFallback('maintenance.title', 'Wartungsarbeiten')
  const displayMessage = message ?? getTranslationWithFallback('maintenance.message', 'Wir arbeiten gerade an Verbesserungen und sind bald wieder da.')
  const displayThankYou = getTranslationWithFallback('maintenance.thankYou', 'Vielen Dank für Ihr Verständnis.')

  return (
    <IonPage className="maintenance-screen cert-page">
      <Header title={displayTitle} />
      <IonContent>
        <div className="card maintenance-screen__card">
          <IonGrid>
            <IonRow>
              <IonCol className="ion-text-center">
                <div className="maintenance-screen__rbl-logo">
                  <IonImg src="/assets/rbl25/rbl_logo.svg" alt="RB Leipzig" />
                </div>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol className="ion-text-center">
                <div className="maintenance-screen__icon">
                  <IonIcon icon={constructOutline} />
                </div>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol sizeMd="8" offsetMd="2">
                <h2 className="hsv-font-slab ion-no-margin ion-text-center maintenance-screen__title">
                  {displayTitle}
                </h2>
                <div className="ion-margin-top ion-margin-bottom n2br">
                  <IonText>
                    <p>{displayMessage}</p>
                  </IonText>
                </div>
                <div className="ion-margin-top">
                  <IonText color="medium">
                    <p><em>{displayThankYou}</em></p>
                  </IonText>
                </div>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol className="ion-text-center">
                <div className="maintenance-screen__jmt-footer">
                  <IonImg src="/assets/jmtcompanyblack.svg" alt="Join My Talent" />
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default MaintenanceScreen
